/* global axios */
import ApiClient from './ApiClient';

class AtecProductsAPI extends ApiClient {
  constructor() {
    super('atec_products', { accountScoped: true });
  }

  search(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params || {}).forEach(k => {
      if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
        query.append(k, params[k]);
      }
    });
    const url = query.toString() ? `${this.url}?${query.toString()}` : this.url;
    if (typeof window !== 'undefined' && window.axios)
      return window.axios.get(url);
    return axios.get(url);
  }
}

export default new AtecProductsAPI();
